export default __webpack_public_path__ + "static/media/occupy-defi.0a3cbb37.jpeg";